module.exports = __webpack_public_path__ + "img/reporting.e036c280.svg";